import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { trackYandexPageView } from '@/shared/lib/yandex-metrica';

export function YandexMetricaPageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    const routeUrl = `${location.pathname}${location.search}${location.hash}`;
    trackYandexPageView(routeUrl, document.title);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
